<template>
  <div>
    <div class="content-header">
      <h2>人才培训</h2>
    </div>
    <div class="content-con">
      <div class="content-de">
        <div class="profile-left">
          <ul class="tab">
            <li
              v-for="(item, index) in tabs"
              :key="index"
              class="tab-item"
              :class="{ 'item--active': Mode == index + 1 }"
              @click="toggleLoginMode(index + 1)"
            >
              <span>{{ item }}</span>
              <svg
                t="1646814029695"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3041"
                width="500"
                height="500"
              >
                <path
                  d="M511.706311 512m-63.960731 0a62.504 62.504 0 1 0 127.921461 0 62.504 62.504 0 1 0-127.921461 0Z"
                  p-id="3042"
                  fill="#cbcbc6"
                ></path>
                <path
                  d="M255.863389 512m-63.960731 0a62.504 62.504 0 1 0 127.921461 0 62.504 62.504 0 1 0-127.921461 0Z"
                  p-id="3043"
                  fill="#cbcbc6"
                ></path>
                <path
                  d="M767.54821 512m-63.960731 0a62.504 62.504 0 1 0 127.921461 0 62.504 62.504 0 1 0-127.921461 0Z"
                  p-id="3044"
                  fill="#cbcbc6"
                ></path>
              </svg>
            </li>
          </ul>
        </div>
        <div class="profile-right">
          <div v-if="Mode == 1">
            <educational-orientation></educational-orientation>
          </div>
          <div v-if="Mode == 2">
            <business-profile></business-profile>
          </div>
          <div v-if="Mode == 3">
            <training-policy></training-policy>
          </div>
          <div v-if="Mode == 4">
            <training-program></training-program>
          </div>
          <div v-if="Mode == 5">
            <field-teaching-base></field-teaching-base>
          </div>
          <div v-if="Mode == 6">
            <brochure-information></brochure-information>
          </div>
        </div>
      </div>

      <!-- <div id="content_box-16929421955701-1" class="d_gridCell_1 p_gridCell">
        <div id="c_static_001-16929421959015" class="response-animated">
          <div class="e_richText-1 s_title clearfix response-transition">
            <p style="text-indent: 2em">
              <span style="line-height: 2"
                >湖北人才发展集团将在培训业务上积极响应人才强省战略，以多维的产品类型、丰富的平台资源和优质的服务保障为核心优势，有针对性地开展培训项目。从党建与红色教育、专题讲座、专业类培训、通识与管理类培训、对标学习、体验式培训、专题会议、产教融合到数字化学习平台，提供多层次、多领域的人才培训服务。拥有丰富的经验和专业团队，与政府、高校、企业合作紧密，致力于成为全省人才培训领域的引领者，为湖北乃至全国的人才发展提供强有力的支持与服务。</span
              >
            </p>

            <p style="text-indent: 2em">&nbsp;</p>

            <p style="margin-top: 20px">
              <img
                alt="1"
                id="1701838079513464832"
                src="https://omo-oss-image.thefastimg.com/portal-saas/new2023072409584008663/cms/image/375eda9a-3db1-4f56-a270-819ade8ef93c.jpg"
                style="max-width: 100%; width: 100%; height: auto"
              />
            </p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      Mode: "1",
      tabs: [
        "教育定位",
        "业务简介",
        "干训政策",
        "培训项目",
        "现场教学基地（湖北）​",
        "宣传册资料",
      ],
    };
  },
  created() {
    if (this.id) {
      this.Mode = this.id;
    }
  },
  methods: {
    toggleLoginMode(mode) {
      this.Mode = mode;
    },
  },
};
</script>
<style lang="less" scoped>
.content-con {
  padding-top: 30px;
  .content-de {
    display: flex;
    justify-content: space-between;
    .profile-left {
      width: 25%;
      .tab-item {
        width: 80%;
        padding: 20px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid rgba(235, 235, 235, 1);
        border-radius: 4px;
        background: #f3f0f0;
        margin: 10px 0;
        svg {
          margin: 0;
          height: 100%;
          width: 15px;
        }
      }
      .item--active {
        background: #00a0e9;
        color: #fff;
      }
    }
    .profile-right {
      width: 75%;
      box-shadow: 0px 9px 20px 0px #c2c1c180;
      padding: 20px;
    }
  }
}
// #c_static_001-16929421959015 {
//   min-height: 0px;
//   display-radio: 1;
//   background-color: rgba(255, 255, 255, 1);
//   width: 100%;
//   max-width: none;
//   margin-left: auto;
//   margin-right: 0px;
//   padding-top: 30px;
//   padding-bottom: 30px;
//   padding-left: 30px;
//   padding-right: 30px;
// }

// #c_static_001-16929421959015 .e_richText-1 {
//   font_radio: 2;
//   display-radio: 1;
//   font-size: 16px;
//   color: #333333;
//   line-height: 1.8;
//   font-family: Microsoft YaHei;
//   text-align: justify;
// }

// #c_static_001-16929421959015 .e_text-2 {
//   line-height: 1;
//   max-width: none;
//   font_radio: 2;
//   display-radio: 1;
//   font-size: 30px;
//   font-family: Microsoft YaHei;
//   font-weight: normal;
//   text-align: left;
//   margin-left: 0px;
//   margin-right: auto;
//   color: rgba(51, 51, 51, 1);
// }

// #c_static_001-16929421959015 .e_container-5 {
//   display: flex;
//   flex-wrap: wrap;
//   flex-direction: row;
//   width: 100%;
//   display-radio: flex;
//   border-bottom: 1px solid #ddd;
//   padding-bottom: 15px;
//   margin-bottom: 15px;
// }

// #c_static_001-16929421959015 .e_container-5 > .p_item {
//   flex: 1;
//   max-width: 100%;
//   max-height: 100%;
// }

// #c_static_001-16929421959015 .e_container-5 .cbox-5-0 {
//   flex: 0 0 230px;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .p_breadcrumbItem {
//   position: relative;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .icon {
//   width: 12px;
//   height: 12px;
// }

// #c_static_001-16929421959015
//   .e_breadcrumb-6
//   .p_breadcrumbItem:not(:first-child) {
//   padding: 0 0px 0 20px;
// }

// #c_static_001-16929421959015
//   .e_breadcrumb-6
//   .p_breadcrumbItem:not(:first-child)::before {
//   content: ">";
//   position: absolute;
//   left: 5px;
//   color: #999;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .p_breadcrumb {
//   display: flex;
//   justify-content: flex-end;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .p_showTitle {
//   position: relative;
//   display: flex;
//   align-items: center;
//   padding-left: 0px;
//   border: 1px solid transparent;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .siblings::after {
//   content: ">";
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 20px;
//   height: 20px;
//   transform: rotateZ(90deg);
//   cursor: pointer;
//   color: #ccc;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .siblings.active {
//   border: 1px solid #dee2e6;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .siblings.active::after {
//   transform: rotateZ(-90deg);
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .p_slide {
//   position: absolute;
//   left: 18px;
//   min-width: 100%;
//   padding: 5px;
//   display: none;
//   z-index: 999;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 .p_sibling {
//   display: block;
//   width: 100%;
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }

// #c_static_001-16929421959015 .e_breadcrumb-6 {
//   background_radio: 2;
//   background-color: rgba(255, 255, 255, 0);
// }

// #c_static_001-16929421959015 .p_breadcrumb .p_breadcrumbItem span {
//   line-height: 1.5;
// }

// #c_static_001-16929421959015 .p_breadcrumb .p_breadcrumbItem .p_showTitle {
//   line-height: 1.5;
//   color: #6c757d;
// }

// #c_static_001-16929421959015 .p_breadcrumb .p_breadcrumbItem:nth-child(3) a {
//   color: #212529;
// }

// @media screen and (max-width: 768px) {
//   #c_static_001-16929421959015 {
//     display-radio: 1;
//     padding-top: 0px;
//     padding-bottom: 0px;
//     padding-left: 0px;
//     padding-right: 0px;
//     width: 100%;
//   }

//   #c_static_001-16929421959015 .e_text-2 {
//     max-width: none;
//     font-size: 20px;
//   }

//   #c_static_001-16929421959015 .e_richText-1 {
//     font-size: 14px;
//   }

//   #c_static_001-16929421959015 .e_breadcrumb-6 {
//     display: none;
//   }

//   #c_static_001-16929421959015 .e_container-5 {
//     padding-bottom: 15px;
//     margin-bottom: 10px;
//   }

//   #c_static_001-16929421959015 .e_container-5 .cbox-5-0 {
//     flex: 0 0 100%;
//   }
// }

// @media screen and (min-width: 769px) {
// }

// @media screen and (max-width: 1024px) and (min-width: 769px) {
// }
</style>
